import Product from "@/models/Product";

export default class Cart {
	public product: Product|any = null
	public count: any = 0
}
